(async () => {
	if( whippetStateData.stateApiUrl ) {
		const response = await fetch( whippetStateData.stateApiUrl );

		window.whippetState = await response.json();

		document.dispatchEvent( new CustomEvent( 'whippetStateChanged', {
			detail: {
				state: window.whippetState,
			}
		} ) );
	}
})();
